import { render } from "./MasterDataKpiTargetKonsolidasiForm.vue?vue&type=template&id=2336021c&scoped=true"
import script from "./MasterDataKpiTargetKonsolidasiForm.vue?vue&type=script&lang=js"
export * from "./MasterDataKpiTargetKonsolidasiForm.vue?vue&type=script&lang=js"

import "./MasterDataKpiTargetKonsolidasiForm.vue?vue&type=style&index=0&id=2336021c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2336021c"]])

export default __exports__